import { render, staticRenderFns } from "./TablaClients.vue?vue&type=template&id=6b7f8e99&"
import script from "./TablaClients.vue?vue&type=script&lang=js&"
export * from "./TablaClients.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports